var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "50px" },
          attrs: {
            title:
              "查看批次商品库存流水【批号：" + _vm.currentBatchNumber + "】",
            width: 1000,
            visible: _vm.visible,
            confirmLoading: false,
            footer: null,
            maskClosable: false,
            zIndex: 900,
            bodyStyle: { height: "500px", overflowY: "auto" },
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据编号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入单据编号" },
                                    model: {
                                      value: _vm.queryParam.number,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "number", $$v)
                                      },
                                      expression: "queryParam.number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据日期",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: ["开始日期", "结束日期"],
                                    },
                                    on: { change: _vm.onDateChange },
                                    model: {
                                      value: _vm.queryParam.dateRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "dateRange",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.dateRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                            _c(
                              "span",
                              {
                                staticClass: "table-page-search-submitButtons",
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.searchQuery },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.searchReset },
                                  },
                                  [_vm._v("重置")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportExcel },
                                  },
                                  [_vm._v("导出")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("a-table", {
                ref: "table",
                attrs: {
                  bordered: "",
                  size: "middle",
                  rowKey: "id",
                  columns: _vm.flowColumns,
                  dataSource: _vm.flowDataSource,
                  pagination: false,
                  scroll: { x: true },
                  loading: _vm.loading,
                },
                on: { change: _vm.handleFlowTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "numberCustomRender",
                    fn: function (text, record) {
                      return _c("span", {}, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleNumberClick(record)
                              },
                            },
                          },
                          [_vm._v(_vm._s(record.number))]
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _c(
                "a-row",
                {
                  staticStyle: { "margin-top": "8px", textAlign: "right" },
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 24, sm: 24 } },
                    [
                      _c("a-pagination", {
                        attrs: {
                          size: "small",
                          "show-size-changer": "",
                          "show-quick-jumper": "",
                          current: _vm.flowPagination.current,
                          "page-size": _vm.flowPagination.pageSize,
                          "page-size-options":
                            _vm.flowPagination.pageSizeOptions,
                          total: _vm.flowPagination.total,
                        },
                        on: {
                          change: _vm.flowPaginationChange,
                          showSizeChange: _vm.flowPaginationShowSizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("bill-detail", {
        ref: "modalDetail",
        on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }